import { Component, OnInit, ViewChild } from '@angular/core';
import { PilotsService } from '../../shared/services/pilots.service';
import { IPilotOverride } from '../pay-scales/pay-scales.types';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseComponent } from '../base.component';
import { AlertService } from '../../core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { OverrideEmployeeDialogComponent } from '../dialogs/override-employee-dialog/override-employee-dialog.component';
import { EmploymentStatusEnum } from './EmploymentStatusEnum';
import { MatSort } from '@angular/material/sort';

@Component({
	selector: 'app-override-employees',
	templateUrl: './override-employees.component.html',
	styleUrls: ['./override-employees.component.scss']
})
export class OverrideEmployeesComponent extends BaseComponent implements OnInit {
	get employmentStatuses(): any {
		return EmploymentStatusEnum;
	}

	constructor(protected alertService: AlertService, private pilotsService: PilotsService, private dialog: MatDialog) {
		super(alertService);
	}
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	public filterText: string = '';
	public isLoading: boolean = true;
	public employees: MatTableDataSource<IPilotOverride>;
	public employee: IPilotOverride;
	public employeeDialogRef: Subscription;
	public hiddenFromList: boolean;
	public displayedEmployeesColumns: string[] = [
		'lastName',
		'emailAddress',
		'phoneStipend',
		'jobTitle',
		'aircraftModel',
		'newJobTitle',
		'newAircraftModel',
		'effectiveDate',
		'employmentStatus'
	];

	ngOnInit(): void {
		this.isLoading = true;
		this.getPilotsWithOverrideData();
	}

	public getPilotsWithOverrideData(): void {
		this.pilotsService.getPilotsWithOverrideData(true).subscribe(
			data => {
				this.employees = new MatTableDataSource<IPilotOverride>(data);
				this.setFilter();
				this.isLoading = false;
			},
			(error: HttpErrorResponse) => {
				this.handleError(error);
			}
		);
	}

	public openOverrideEmployeeDialog(employee: IPilotOverride): void {
		const dialogConfig: MatDialogConfig = new MatDialogConfig();

		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.data = { employee };

		if (this.dialog) {
			this.employeeDialogRef = this.dialog
				.open(OverrideEmployeeDialogComponent, dialogConfig)
				.afterClosed()
				.subscribe((isTrue: boolean) => {
					if (isTrue) {
						this.getPilotsWithOverrideData();
					}
				});
		}
	}

	public filterEmployees(): void {
		this.employees.filter = this.filterText
			? this.filterText.trim().toLocaleLowerCase()
			: this.hiddenFromList
			? '0'
			: '';
	}

	public getTextFilterPredicate(data: any): any {
		let textPredicate: any = '';

		if (this.filterText) {
			textPredicate =
				data.firstName.toLowerCase().indexOf(this.filterText.trim().toLocaleLowerCase()) !== -1 ||
				data.lastName.toLowerCase().indexOf(this.filterText.trim().toLocaleLowerCase()) !== -1 ||
				data.emailAddress.toLowerCase().indexOf(this.filterText.trim().toLocaleLowerCase()) !== -1;
			if (textPredicate) {
				if (this.hiddenFromList) {
					return !data.showInLists && textPredicate;
				} else {
					return textPredicate;
				}
			}
		} else {
			return !data.showInLists;
		}
	}

	public hiddenFromListFilter(): void {
		this.employees.filter = this.hiddenFromList ? '0' : this.filterText.toLowerCase();
	}

	private setFilter(): void {
		this.employees.sort = this.sort;

		// Custom sorting accessor to map column names to actual data properties
		this.employees.sortingDataAccessor = (data: IPilotOverride, sortHeaderId: string): string | number => {
			switch (sortHeaderId) {
				case 'jobTitle':
					return data.jobTitleName || '';
				case 'aircraftModel':
					return data.aircraftModelName || '';
				case 'newJobTitle':
					return data.scheduledChanges?.jobTitleName || '';
				case 'newAircraftModel':
					return data.scheduledChanges?.aircraftModelName || '';
				case 'effectiveDate':
					return data.scheduledChanges?.effectiveStart ? new Date(data.scheduledChanges.effectiveStart).getTime() : 0;
				case 'phoneStipend':
					return data.receivesPhoneStipend ? 1 : 0;
				default:
					const value: any = data[sortHeaderId as keyof IPilotOverride];
					return value != null ? String(value) : '';
			}
		};

		this.employees.filterPredicate = (data: any) => {
			return this.getTextFilterPredicate(data);
		};
		this.filterEmployees();
		this.hiddenFromListFilter();
	}
}
